import * as types from './constants';

export const initialState = {
  data: null,
  loading: false,
  errors_api: {}
};

const actions = {
  [types.GET_NETWORK_ORDERS_SUMMARY_REQUEST]: state => ({
    ...state,
    loading: true
  }),

  [types.GET_NETWORK_ORDERS_SUMMARY_DONE]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }),

  [types.GET_NETWORK_ORDERS_SUMMARY_FAILED]: (state, { payload }) => ({
    ...state,
    loading: false,
    errors_api: payload
  })
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
